const addressesCheckModel = vm => ({
  title: vm.$gettext('Shippings'),
  endpoint: 'shippings',
  fields: [
    {
      key: 'id',
      sortable: true
    },
    {
      key: 'to_meta',
      sortable: false,
      label: vm.$gettext('Instruct.')
    },
    {
      key: 'meta.ai.addresses.to.aiAddress.original',
      sortable: false,
      label: vm.$gettext('Original')
    },
    {
      key: 'meta.ai.addresses.to.aiAddress.clean',
      sortable: false,
      label: vm.$gettext('Clean')
    },
    {
      key: 'meta.ai.addresses.to.aiAddress.place.formatted_address',
      sortable: false,
      label: vm.$gettext('GPlaces')
    },
    {
      key: 'meta.ai.addresses.to.aiAddress.engine',
      sortable: false,
      label: vm.$gettext('Engine')
    },
    {
      key: 'meta.ai.addresses.to.aiAddress.confidence',
      sortable: true,
      label: vm.$gettext('Confidence')
    },
    {
      key: 'address_to.formatted_address',
      sortable: false,
      label: vm.$gettext('Manual Selected')
    },
    {
      key: 'updated_at',
      label: vm.$gettext('Updated At'),
      sortable: true
    }
  ],
  filters: ['id', 'updated_at', 'meta', 'to_country_iso_code'],
  includes: [],
  highPerformanceIncludes: []
})

export default addressesCheckModel
